import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { AssessmentResult, AssessmentSettings } from '@shared/models';
import { getAssessmentDisplayParams, setupAssessmentChart } from '@shared/utils/assessment.utils';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'assessment-card',
  templateUrl: './assessment-card.component.html',
  styleUrls: ['./assessment-card.component.scss']
})
export class AssessmentCardComponent implements OnInit {
  @Input() assessmentSettings: AssessmentSettings;
  @Input() assessment: AssessmentResult;
  @Input() previewMode = false;
  @Output() showAssessment = new EventEmitter<AssessmentResult>();

  public displayParams: any;
  public chartOption: EChartsOption;

  ngOnInit(): void {
    this.displayParams = getAssessmentDisplayParams(this.assessment, this.assessmentSettings);
    this.chartOption = setupAssessmentChart(this.assessment, this.displayParams.scoreMax, true);
  }

  onCardClick() {
    this.showAssessment.emit(this.assessment);
  }
}
